import type { PropsWithChildren } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { clsx } from 'clsx';

import styles from './styles/Card.module.scss';

export type CardVariantProps = VariantProps<typeof cardVariants>;
const cardVariants = cva(styles.card, {
  variants: {
    variant: {
      primary: styles.primary,
      secondary: styles.secondary,
    },
  },
  defaultVariants: {
    variant: 'primary',
  },
});

export interface CardProps extends PropsWithChildren<CardVariantProps> {
  borderRadius?: 's' | 'm' | 'l';
  className?: string;
  height?: string;
  padding?: 's' | 'm' | 'l';
  shouldCenter?: boolean;
}

const Card = ({
  borderRadius = 'm',
  children,
  className,
  height,
  padding,
  shouldCenter,
  variant,
  ...props
}: CardProps) => {
  const style = height ? { '--cxy-card-height': height } : {};
  return (
    <div
      className={clsx(
        cardVariants({ variant }),
        {
          [styles[`padding-${padding}`]]: padding && typeof padding === 'string',
          [styles.shouldCenter]: shouldCenter,
          [styles[`borderRadius-${borderRadius}`]]: borderRadius,
        },
        className,
      )}
      data-cxy-name="card"
      style={style}
      {...props}
    >
      {children}
    </div>
  );
};

export { Card };
